import { render, staticRenderFns } from "./costDetails.vue?vue&type=template&id=04a44a32&scoped=true&"
import script from "./costDetails.vue?vue&type=script&lang=js&"
export * from "./costDetails.vue?vue&type=script&lang=js&"
import style0 from "./costDetails.vue?vue&type=style&index=0&id=04a44a32&lang=less&scoped=true&"
import style1 from "./costDetails.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a44a32",
  null
  
)

export default component.exports